export const GraduationCapIcon = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="graduation-cap-icon">
    <defs>
      <linearGradient id="capGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#1f2937', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#f4f4f5', stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="capTopGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#f4f4f5', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#f4f4f5', stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="tasselGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#fbbf24', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#f59e0b', stopOpacity: 1 }} />
      </linearGradient>
      <filter id="capShadow">
        <feGaussianBlur stdDeviation="1.5" result="coloredBlur" />
        <feOffset dx="0" dy="2" result="offsetBlur" />
        <feMerge>
          <feMergeNode in="offsetBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {/* Mortarboard (square cap top) */}
    <g className="mortarboard" filter="url(#capShadow)">
      {/* Square board - top view */}
      <path
        d="M 30 35 L 70 35 L 70 45 L 30 45 Z"
        fill="url(#capTopGradient)"
        className="board-top"
      />

      {/* Board 3D edges for depth */}
      <path
        d="M 30 45 L 28 47 L 68 47 L 70 45 Z"
        fill="#0f172a"
        opacity="0.8"
        className="board-bottom"
      />
      <path d="M 70 35 L 72 37 L 72 47 L 70 45 Z" fill="#1f2937" className="board-right" />

      {/* Center button/decoration */}
      <circle cx="50" cy="40" r="2.5" fill="#fbbf24" className="center-button" />
      <circle cx="50" cy="40" r="1.5" fill="#f59e0b" className="center-button-inner" />
    </g>

    {/* Tassel */}
    <g className="tassel-group">
      {/* Tassel cord */}
      <path
        d="M 50 40 Q 52 32 56 28"
        fill="none"
        stroke="url(#tasselGradient)"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="tassel-cord"
      />

      {/* Tassel knot/button at top */}
      <circle cx="56" cy="28" r="2.5" fill="#fbbf24" className="tassel-knot" />

      {/* Tassel threads hanging down */}
      <g className="tassel-threads">
        <path
          d="M 56 28 L 54 38"
          stroke="#f59e0b"
          strokeWidth="1.5"
          opacity="0.9"
          strokeLinecap="round"
        />
        <path
          d="M 56 28 L 56 39"
          stroke="#fbbf24"
          strokeWidth="1.8"
          opacity="1"
          strokeLinecap="round"
        />
        <path
          d="M 56 28 L 58 38"
          stroke="#f59e0b"
          strokeWidth="1.5"
          opacity="0.9"
          strokeLinecap="round"
        />
        <path
          d="M 56 28 L 55 37"
          stroke="#fbbf24"
          strokeWidth="1.2"
          opacity="0.8"
          strokeLinecap="round"
        />
        <path
          d="M 56 28 L 57 37"
          stroke="#fbbf24"
          strokeWidth="1.2"
          opacity="0.8"
          strokeLinecap="round"
        />

        {/* Tassel end bundle */}
        <ellipse
          cx="56"
          cy="38"
          rx="2.5"
          ry="1.5"
          fill="#f59e0b"
          opacity="0.8"
          className="tassel-end"
        />
      </g>
    </g>

    {/* Skull cap (the part that sits on head) */}
    <g className="skull-cap">
      <ellipse cx="50" cy="50" rx="12" ry="7" fill="url(#capGradient)" className="cap-base" />
      <ellipse
        cx="50"
        cy="48"
        rx="12"
        ry="3"
        fill="#374151"
        opacity="0.6"
        className="cap-top-rim"
      />

      {/* Inner shadow for depth */}
      <ellipse cx="50" cy="51" rx="10" ry="5" fill="#0f172a" opacity="0.4" className="cap-inner" />
    </g>

    {/* Sparkles/Shine effects */}
    <g className="cap-sparkles">
      <circle cx="35" cy="37" r="1" fill="#fbbf24" className="sparkle sparkle-1" opacity="0.8" />
      <circle cx="65" cy="38" r="1.2" fill="#60a5fa" className="sparkle sparkle-2" opacity="0.7" />
      <circle cx="45" cy="33" r="0.8" fill="#ffffff" className="sparkle sparkle-3" opacity="0.9" />
    </g>

    {/* Achievement stars */}
    <g className="achievement-stars">
      <path
        d="M 18 40 L 19 42.5 L 21.5 42.5 L 19.5 44 L 20 46.5 L 18 45 L 16 46.5 L 16.5 44 L 14.5 42.5 L 17 42.5 Z"
        fill="#fbbf24"
        className="achievement-star star-1"
        opacity="0.7"
      />
      <path
        d="M 82 42 L 83 44.5 L 85.5 44.5 L 83.5 46 L 84 48.5 L 82 47 L 80 48.5 L 80.5 46 L 78.5 44.5 L 81 44.5 Z"
        fill="#60a5fa"
        className="achievement-star star-2"
        opacity="0.6"
      />
    </g>
  </svg>
)

// Add this right after the GraduationCapIcon component

